export const environment = {
  production: true,
  apiBaseUrl: 'https://bonanza4all.com/api/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts